import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { SubsetSuggestion } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetSuggestedSubsets = () => {
  const { matterId } = useParams<{ matterId: string }>();
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<SubsetSuggestion[]>(
    [QueryEntity.SubsetSuggestions, matterId],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matter/${matterId}/subset/suggestions`, fetchConfigGET);
      if (!res.ok) {
        throw new Error('Failed to fetch suggestions');
      }
      return res.json();
    },
    {
      enabled: !!matterId,
    },
  );
};
